module.exports = {
  "zones": {
    "Europe/Istanbul": ["z", {
      "wallclock": 1473206400000,
      "format": "+03",
      "abbrev": "+03",
      "offset": 10800000,
      "posix": 1473195600000,
      "save": 0
    }, {
      "wallclock": 1446955200000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 1446944400000,
      "save": 0,
      "rules": "EU"
    }, {
      "wallclock": 1445745600000,
      "format": "EEST",
      "abbrev": "EEST",
      "offset": 7200000,
      "posix": 1445734800000,
      "save": 3600000
    }, {
      "wallclock": 1396234800000,
      "format": "EE%sT",
      "abbrev": "EEST",
      "offset": 7200000,
      "posix": 1396227600000,
      "save": 3600000,
      "rules": "EU"
    }, {
      "wallclock": 1396148400000,
      "format": "EET",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 1396141200000,
      "save": 0
    }, {
      "wallclock": 1301281200000,
      "format": "EE%sT",
      "abbrev": "EEST",
      "offset": 7200000,
      "posix": 1301274000000,
      "save": 3600000,
      "rules": "EU"
    }, {
      "wallclock": 1301194800000,
      "format": "EET",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 1301187600000,
      "save": 0
    }, {
      "wallclock": 1167609600000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": 1167602400000,
      "save": 0,
      "rules": "EU"
    }, {
      "wallclock": 482803200000,
      "format": "EE%sT",
      "abbrev": "EEST",
      "offset": 7200000,
      "posix": 482792400000,
      "save": 3600000,
      "rules": "Turkey"
    }, {
      "wallclock": 277257600000,
      "format": "+03/+04",
      "abbrev": "+04",
      "offset": 10800000,
      "posix": 277246800000,
      "save": 3600000,
      "rules": "Turkey"
    }, {
      "wallclock": -1869868800000,
      "format": "EE%sT",
      "abbrev": "EET",
      "offset": 7200000,
      "posix": -1869875816000,
      "save": 0,
      "rules": "Turkey"
    }, {
      "wallclock": -2840140800000,
      "format": "IMT",
      "abbrev": "IMT",
      "offset": 7016000,
      "posix": -2840147752000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 6952000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "EU": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1984,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1982,
      "to": 1983,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1981,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1980,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "Turkey": [{
      "from": 1995,
      "to": 2006,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1986,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1994,
      "to": 1994,
      "month": 2,
      "day": [7, 20],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1986,
      "to": 1993,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1985,
      "to": 1985,
      "month": 3,
      "day": [7, 20],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1985,
      "to": 1985,
      "month": 8,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1983,
      "to": 1983,
      "month": 6,
      "day": [7, 31],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1983,
      "to": 1983,
      "month": 9,
      "day": [7, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1979,
      "to": 1982,
      "month": 9,
      "day": [1, 11],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1982,
      "month": 2,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1980,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1979,
      "month": 3,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1978,
      "month": 3,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1977,
      "to": 1977,
      "month": 9,
      "day": [7, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1975,
      "to": 1976,
      "month": 9,
      "day": [0, -31],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1976,
      "to": 1976,
      "month": 5,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1975,
      "month": 2,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 2,
      "day": [7, 31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 10,
      "day": [7, 3],
      "time": 300,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1973,
      "to": 1973,
      "month": 5,
      "day": [7, 3],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1973,
      "to": 1973,
      "month": 10,
      "day": [7, 4],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1970,
      "to": 1972,
      "month": 4,
      "day": [0, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1970,
      "to": 1972,
      "month": 9,
      "day": [0, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1964,
      "to": 1964,
      "month": 4,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1964,
      "to": 1964,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1962,
      "to": 1962,
      "month": 6,
      "day": [7, 15],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1962,
      "to": 1962,
      "month": 9,
      "day": [7, 8],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1951,
      "to": 1951,
      "month": 3,
      "day": [7, 22],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1951,
      "to": 1951,
      "month": 9,
      "day": [7, 8],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1947,
      "to": 1950,
      "month": 9,
      "day": [0, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1950,
      "to": 1950,
      "month": 3,
      "day": [7, 19],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1949,
      "to": 1949,
      "month": 3,
      "day": [7, 10],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1948,
      "month": 3,
      "day": [0, 16],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 5,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 3,
      "day": [7, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 9,
      "day": [7, 8],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 3,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1942,
      "month": 10,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1941,
      "to": 1941,
      "month": 8,
      "day": [7, 21],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 5,
      "day": [7, 30],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1940,
      "to": 1940,
      "month": 9,
      "day": [7, 5],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 11,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1924,
      "to": 1925,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1925,
      "to": 1925,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1924,
      "to": 1924,
      "month": 4,
      "day": [7, 13],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1922,
      "to": 1922,
      "month": 2,
      "day": [7, 26],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1922,
      "to": 1922,
      "month": 9,
      "day": [7, 8],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 3,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1921,
      "to": 1921,
      "month": 9,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1920,
      "to": 1920,
      "month": 2,
      "day": [7, 28],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1920,
      "to": 1920,
      "month": 9,
      "day": [7, 25],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1916,
      "to": 1916,
      "month": 4,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 9,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};